// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../common.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._3TomBeqrx{}._5RGSOLCPx{}\n", ""]);
// Exports
exports.locals = {
	"container": "_3TomBeqrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["container"] + "",
	"got-it": "_5RGSOLCPx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["standalone-anchor"] + "",
	"gotIt": "_5RGSOLCPx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["standalone-anchor"] + ""
};
module.exports = exports;
